<template>
  <MainTabEvents :main-title="mainTitle" :secondary-title="secondaryTitle">
    <div class="dea-heading--regular__s generic-container generic-container--warning">
      <p>
        Stiamo lavorando per aggiornare e migliorare Deascuola Formazione: al momento puoi consultare solo le
        informazioni e i materiali degli eventi che si sono tenuti (e si terranno) dal 1 Gennaio 2024 in poi.<br />
        L’archivio di tutti gli eventi precedenti a questa data sarà nuovamente disponibile appena possibile.<br />
        Grazie.
      </p>
    </div>
    <div
      v-if="ticketFilter === 'past'"
      class="main-tab__not-attended-events-link"
      @click="setTicketFilter('notAttended')"
    >
      <Links class="dea-links dea-links--target-color-blue-docenti dea-links--large">
        Vai agli eventi a cui non ho potuto partecipare
      </Links>
    </div>
    <div v-if="ticketFilter === 'festival'" class="main-tab__festival-logo">
      <img :src="logoFestival" alt="logo festival" />
    </div>
    <ContentWrapper v-if="ticketFilter !== 'notAttended'" :class="contentWrapperExtraClasses">
      <template v-if="registrationsLoaded" #default>
        <component
          :is="getTicketWrapperComponent(registration)"
          v-for="registration in filteredRegistrations()"
          :key="`${registration.id}-${versionIndex}`"
          :registration="registration"
          :package-children="findPackageChildren(registration.id)"
          :waiting-for-payment="registration.to_be_completed"
          :ticket-filter="ticketFilter"
          @changeState="changeView($event)"
          @editLaboratories="editLaboratories"
          @completeSurvey="completeSurvey"
          @downloadFiles="downloadFiles"
        >
          <TicketCard
            :registration="registration"
            :package-children="findPackageChildren(registration.id)"
            @registrationDetail="focusRegistration(registration)"
            @editLaboratories="editLaboratories(registration)"
            @completeSurvey="completeSurvey(registration)"
            @downloadFiles="downloadFiles(registration)"
            @cancelRegistration="triggerRegistrationCancel(registration)"
          ></TicketCard>
          <div v-if="registration.state === 'on_hold'" class="order-confirmation-payment dea-border-grey-medium">
            <OrderConfirmationBodyPayment
              :order="registration.order_data"
              :show-payment-choice="false"
            ></OrderConfirmationBodyPayment>
          </div>
        </component>
        <div v-if="filteredRegistrations().length === 0">
          <h2 class="dea-heading--medium__ml">{{ noEventsTitle }}</h2>
        </div>
        <Modal
          class="dea-modal--survey-reminder dea-modal--no-footer"
          :visible="showModal"
          :is-error="false"
          @modalClose="showModal = false"
        >
          <template #title>Completa il questionario</template>
          <template #content>
            <div class="dea-heading--medium__ms">Per visualizzare i materiali completa prima il questionario.</div>
          </template>
        </Modal>
      </template>
    </ContentWrapper>
    <template v-if="ticketFilter === 'waitingList' && preRegistrations().length > 0" #interest-courses>
      <PreRegistrationsHeader
        :types="eventTypes(preRegistrations())"
        :title="secondaryTitle"
        @change="setPreRegistrationsFilter"
      ></PreRegistrationsHeader>
      <ContentWrapper>
        <TicketCard
          v-for="registration in filteredPreRegistrations()"
          :key="`${registration.id}-${versionIndex}`"
          :registration="registration"
          @registrationDetail="focusRegistration(registration)"
          @editLaboratories="editLaboratories(registration)"
          @completeSurvey="completeSurvey(registration)"
          @downloadFiles="downloadFiles(registration)"
          @cancelRegistration="triggerRegistrationCancel(registration)"
        ></TicketCard>
      </ContentWrapper>
    </template>
    <ContentWrapper v-if="ticketFilter === 'notAttended'">
      <TicketCard
        v-for="registration in notAttendedRegistrations()"
        :key="`${registration.id}-${versionIndex}`"
        :registration="registration"
      ></TicketCard>
      <div v-if="notAttendedRegistrations().length === 0">
        <h2 class="dea-heading--medium__ml">{{ noEventsTitle }}</h2>
      </div>
    </ContentWrapper>
  </MainTabEvents>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Links from "@/components/elements/Links";
import ModalAlert from "@/components/patterns/ModalAlert";
import Modal from "@/components/patterns/Modal";
import TicketToPayWrapper from "~/components/events/components/TicketToPayWrapper";
import TicketPackage from "~/components/events/components/TicketPackage";
import TicketCard from "~/components/events/components/TicketCard";
import MainTabEvents from "~/components/events/components/MainTabEvents";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import PlaceholderComponent from "~/components/events/components/PlaceholderComponent";
import PreRegistrationsHeader from "~/components/events/components/PreRegistrationsHeader";
import RegistrationCancellationModal from "~/components/events/components/RegistrationCancellationModal";
import OrderConfirmationBodyPayment from "~/components/events/components/OrderConfirmationBodyPayment";
import logoFestival from "~/assets/logo_festival.jpg";

export default {
  name: "EventsTickets",
  components: {
    Links,
    MainTabEvents,
    ContentWrapper,
    TicketToPayWrapper,
    TicketPackage,
    TicketCard,
    PlaceholderComponent,
    PreRegistrationsHeader,
    Modal,
    OrderConfirmationBodyPayment,
  },
  data() {
    return {
      ticketWrapperComponent: "",
      versionIndex: 0,
      preRegistrationFilter: null,
      showModal: false,
      logoFestival,
    };
  },
  computed: {
    ...mapGetters([
      "filteredRegistrations",
      "notAttendedRegistrations",
      "preRegistrations",
      "ticketFilter",
      "titles",
      "myHomeRegistrations",
      "activeRegistration",
      "registrations",
      "activeRegistrationIndex",
      "eventTypes",
      "registrationsLoaded",
    ]),
    noEventsTitle() {
      return this.titles.empty[this.ticketFilter];
    },
    mainTitle() {
      return this.titles.main[this.ticketFilter];
    },
    secondaryTitle() {
      return this.titles.secondary[this.ticketFilter];
    },
    contentWrapperExtraClasses() {
      if (this.filteredRegistrations().length === 0) {
        return "content-wrapper--reduced-margin";
      }
      return "";
    },
  },
  methods: {
    ...mapActions(["fetchRegistration", "cancelRegistration", "fetchRegistrations"]),
    ...mapMutations([
      "setTicketFilter",
      "setRegistrations",
      "setActiveRegistrationIndex",
      "replaceEventsRegistration",
      "replaceRegistration",
      "setActiveRegistrationIndex",
    ]),
    setPreRegistrationsFilter(event) {
      this.preRegistrationFilter = event.target.value;
    },
    filteredPreRegistrations() {
      if (this.preRegistrationFilter && this.preRegistrationFilter !== "default")
        return this.preRegistrations().filter(x => x.linked_event.type === this.preRegistrationFilter);
      return this.preRegistrations();
    },
    focusRegistration(registration) {
      this.$router.push({ name: "registration", params: { registration: registration.id } });
    },
    editLaboratories(registration) {
      this.$router.push({ name: "laboratories", params: { registration: registration.id } });
    },
    completeSurvey(registration) {
      this.$router.push({ name: "personal-data", params: { registration: registration.id } });
    },
    downloadFiles(registration) {
      if (registration.survey_completed_date || (registration.bundle_parent && registration.is_event_attended)) {
        this.$router.push({ name: "download", params: { registration: registration.id } });
      } else {
        this.showModal = true;
      }
    },
    async runRegistrationCancel(originalRegistration) {
      const registration = await this.cancelRegistration(originalRegistration.id);
      if (registration) {
        this.replaceRegistration(registration);
        this.replaceEventsRegistration(registration);
      }
      this.modal.hide();
      this.versionIndex += 1;
    },
    triggerRegistrationCancel(registration) {
      this.modal = ModalAlert.methods.handleException(RegistrationCancellationModal, this.$root.config);
      this.modal.$on("runRegistrationCancel", () => {
        this.runRegistrationCancel(registration);
      });
    },
    getTicketWrapperComponent(registration) {
      if (registration.to_be_completed) {
        return "TicketToPayWrapper";
      }
      if (registration.bundle_children.length > 0) {
        return "TicketPackage";
      }
      return "PlaceholderComponent";
    },
    changeView(event) {
      this.setTicketFilter(event);
    },
    findPackageChildren(registrationId) {
      return Object.values(this.myHomeRegistrations).filter(el => {
        return el.bundle_parent === registrationId;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.subscription-container {
  &__paragraph {
    margin-bottom: $space-base;
    margin-top: $space-x-large;
  }
}

.main-tab {
  &__not-attended-events-link {
    margin-top: $space-base;
  }
}

.order-confirmation-payment {
  background-color: $dea-color-white;
  border: $border-light;
  border-radius: $border-radius-large;
  margin: $space-small $space-large;
  padding: $space-small;
}

.dea-modal--action__error-icon {
  align-items: center;
  background: $dea-color-feedback-red-negative;
  border-radius: $border-radius-circle;
  display: flex;
  height: $dea-size-large;
  justify-content: center;
  margin-bottom: $space-small;
  padding: 0;
  width: $dea-size-large;

  &:before {
    color: $dea-color-white;
    font-size: $dea-size-medium;
  }
  @include bp-large-max {
    height: $dea-size-intermediate;
    min-width: $dea-size-intermediate;
    width: $dea-size-intermediate;
  }
}

.dea-modal-overlay {
  top: 0 !important; // sass-lint:disable-line no-important

  .dea-modal {
    &__footer {
      justify-content: space-between;
    }
  }
}

.generic-container--warning {
  margin: $space-base 0 !important; // sass-lint:disable-line no-important
}
</style>
